import React, { useEffect, useRef } from 'react'
import ModalBox from '../../components/ModalBox'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import useAxiosPrivate from '../../hooks/use-axios-private'

const PayModal = ({ open, onPaymentComplete, paymentAmount }) => {
    const axios = useAxiosPrivate();
    const paymentWindow = useRef(false)
    const getPaymentUrl = async (amount) => {
        try {
            const resp = await axios.post(`payments/create_order/`, { amount: paymentAmount })
            paymentWindow.current = window.open(resp.data.data.link, "paypal", "popup", 'width=200, height=300')
            var timer = setInterval(function () {
                if (paymentWindow.current && paymentWindow.current.closed) {
                    clearInterval(timer);
                    onPaymentComplete()
                }
            }, 500);
        }
        catch (err) {
            console.error("🚀 ~ file: Subscription.jsx:223 ~ paymentUrl ~ err:", err)
        }
    }
    useEffect(() => {
        if (!isNaN(paymentAmount) && paymentAmount > 0) {
            getPaymentUrl(paymentAmount)
        }
    }, [])
    return (
        <Box>
            <ModalBox
                open={open}
            >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                    <Box>
                        <Typography sx={{ fontSize: "24px", fontWeight: 500 }}>Payment Processing</Typography>
                    </Box>
                    <Box sx={{ mt: 1.2 }}>
                        <Typography>Please complete payment on the Paypal window</Typography>
                    </Box>
                    <Box sx={{ mt: 1.6 }}>
                        <CircularProgress />
                    </Box>
                    <Box sx={{ mt: 2 }}>
                        {paymentWindow.current && <Button variant='outlined' onClick={() => { paymentWindow.current.focus() }}>Show Payment Page</Button>}
                    </Box>
                </Box>
            </ModalBox>
        </Box>
    )
}
PayModal.defaultProps = {
    paymentAmount: 0,
    onPaymentComplete: () => { }
}
export default PayModal